import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[digitalPlatformResponsive],[responsive]',
})
export class ResponsiveDirective implements AfterViewInit {
  ref: ElementRef;
  @Input() responsive?: string;

  constructor(private el: ElementRef) {
    this.ref = el;
  }

  ngAfterViewInit() {
    this.ref.nativeElement.getAttribute('responsive');
    this.ref.nativeElement.classList.add(
      'responsive-section',
      `responsive-${this.responsive}`
    );
  }
}
